import React, { useEffect, useState } from "react";
import ArrowBack from "../../images/arrow-back.svg";
import ArrowNext from "../../images/arrow-next.svg";
import IconTooltip from "../../images/icn-tooltip.svg";
import classNames from "classnames";
import { useDispatch, useSelector } from "react-redux";
import {
  decrementCurrentSlide,
  incrementCurrentSlide,
} from "../../store/slices/slides";

function QuestionFooter() {
  const dispatch = useDispatch();
  const { currentSlide, peekSlide } = useSelector((state) => state.slides);
  const [quickTip, setQuickTip] = useState(false);
  const [offset, setOffset] = useState();
  useEffect(() => {
    setQuickTip(false);
  }, [currentSlide]);
  useEffect(() => {
    if (offset) {
      return;
    }
    setOffset(currentSlide);
  }, []);

  return (
    <div className=" ">
      {/* <div className="relative w-full">
        <div
          className={classNames("cursor-pointer quick-tip", {
            "show-tip": quickTip,
          })}
          onClick={() => setQuickTip(!quickTip)}
        >
          <a className="btn-quick-tip " id="btn_quick_tip">
            <span className="block text-white">quick tip</span>
            <img src={IconTooltip} alt="" />
          </a>
          <div className={"quick-tip-cnt "}>
            Think about how hard it has been lately to stay on top of everything
            going on in your life.
          </div>
        </div>
      </div> */}

      <div className="block-footer-nav">
        {
          <a
            href="#"
            className={`btn btn-prvs break-after-column ${
              currentSlide - offset == 0 && "opacity-50 pointer-events-none"
            }`}
            onClick={() => dispatch(decrementCurrentSlide())}
          >
            <img
              src={ArrowBack}
              alt=""
              className="-mt-0 mb-1 mx-1 inline-block"
            />{" "}
            back
          </a>
        }

        <span className="-mt-2 font-bold">
          question <span className="text-2xl">{currentSlide - offset + 1}</span>
          /9
        </span>

        <a
          href="#"
          className={`btn btn-next ${
            peekSlide <= currentSlide ? "opacity-50 pointer-events-none" : ""
          }`}
          onClick={() => dispatch(incrementCurrentSlide())}
        >
          next{" "}
          <img
            src={ArrowNext}
            alt=""
            className="-mt-0 mb-1 mx-1 inline-block"
          />
        </a>
      </div>
    </div>
  );
}

export default QuestionFooter;
